import { formatDate, getNightDayDuration } from "components/Api/common";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import { Container, Col, Row, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import nightMode from "../../../assets/img/night-mode_9554519@2x.jpg";
import gypsy from "assets/img/Group 90@2x.jpg";
import carSeat from "assets/img/Share-Safari/car-seat_5102816.png";
import Camera from "assets/img/Icon fa-solid-camera@2x.jpg";
import Elephant from "assets/img/Share-Safari/elephant.png";
import Hotel from "assets/img/Icon fa-solid-hotel.png";
import meal from "assets/img/path@2x.jpg";
import texi from "assets/img/Icon fa-solid-taxi.jpg";
import ruppes from "assets/img/rupees.png"
import rupeeFormat from "components/Api/RupeeFormat";
import { useAuth } from "provider/AuthContext";
import { useState } from "react";
import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartSolid, faHistory } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { useToast } from "provider/ToastProvider";
import { useScreenSize } from "provider/ScreenSizeProvider";


const ShareSafariHeader = () => {
  const { organized_slug, safariSlug } = useParams();
  const {isMobileView} = useScreenSize();
  const { showWarningToast } = useToast();
  const { safariViewData, intreastedUsers, totalIntreastedUsers, sharedSafariDispatch } = useSharedSafariContext();
  const { isLoggedIn, userProfile, logout } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [loadingWish, setLoadingWish] = useState();
  const [imageError, setImageError] = useState(false);
  const fullUrl = `https://walkintothewild.in/sharedsafari/${organized_slug}/${safariSlug}`;



  const joinSharedSafari = async () => {
    try {
      setLoading(true)

      const response = await apiCall({
        url: `sharesafari/${safariSlug}/join`,
        method: "POST",
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      //check error after 200/ok
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        sharedSafariDispatch({
          type: "SET_SHARED_SAFARI_VIEW_ERROR",
          payload: apiData.errors,
        });
        console.error("API returned errors:", apiData.errors);
        return;
      }
      // updade shared sfari if status = 1
      if (apiData?.status === 1) {
        sharedSafariDispatch({
          type: 'UPDATE_SHARED_SAFARI_VIEW_DETAILS',
          payload: {
            have_you_joined: true,
          },
        });

        const newUser = {
          username: userProfile.username,
          name: userProfile.name,
          email: userProfile.email,
          is_safari_operator: userProfile.is_safari_operator,
          user_handle: userProfile.user_handle,
          gender: userProfile.gender,
          account_type: userProfile.account_type,
          gender_privacy: userProfile.gender_privacy,
          email_privacy: userProfile.email_privacy,
          status: userProfile.status,
          profile_display_image: userProfile.profile_display_image,
          cover_display_image: userProfile.cover_display_image,
          display_name: userProfile.display_name,
          is_followed: userProfile.is_followed,
          user_activity_count: userProfile.user_activity_count,
          operator_slug: userProfile.operator_slug,
        };
        sharedSafariDispatch({
          type: "SET_SHARED_SAFARI_VIEW_INTRESTED_USERS",
          payload: {
            users: [...intreastedUsers, newUser],
            total: totalIntreastedUsers + 1,
          },
        });
      } else {
        // Catch unexpected success payload with status ≠ 1
        console.warn("Unexpected API status:", apiData?.message);
        showWarningToast(apiData?.message);
      }
    } catch (error) {
      // Optionally dispatch network error

      handleError(error, logout, navigate);
    } finally {
      setLoading(false)
    }
  }

  const unJoinSharedSafari = async () => {
    try {
      setLoading(true)

      const response = await apiCall({
        url: `sharesafari/${safariSlug}/unjoin`,
        method: "POST",
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;
      //check error after 200/ok
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        sharedSafariDispatch({
          type: "SET_SHARED_SAFARI_VIEW_ERROR",
          payload: apiData.errors,
        });
        console.error("API returned errors:", apiData.errors);
        return;
      }
      // updade shared sfari if status = 1
      if (apiData?.status === 1) {
        sharedSafariDispatch({
          type: 'UPDATE_SHARED_SAFARI_VIEW_DETAILS',
          payload: {
            have_you_joined: false,
          },
        });

        const updatedUsers = intreastedUsers.filter(
          user => user.username !== userProfile.username
        );

        sharedSafariDispatch({
          type: "SET_SHARED_SAFARI_VIEW_INTRESTED_USERS",
          payload: {
            users: updatedUsers,
            total: Math.max(0, totalIntreastedUsers - 1),
          },
        });
      }
    } catch (error) {
      // Optionally dispatch network error
      handleError(error, logout, navigate);
    } finally {
      setLoading(false)
    }
  }

  const addInWishList = async () => {
    try {
      setLoadingWish(true)

      const response = await apiCall({
        url: `sharesafari/${safariSlug}/wishlist`,
        method: "POST",
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      //check error after 200/ok
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        sharedSafariDispatch({
          type: "SET_SHARED_SAFARI_VIEW_ERROR",
          payload: apiData.errors,
        });
        console.error("API returned errors:", apiData.errors);
        return;
      }
      // updade shared sfari if status = 1
      if (apiData?.status === 1) {
        sharedSafariDispatch({
          type: 'UPDATE_SHARED_SAFARI_VIEW_DETAILS',
          payload: {
            is_wishlist: true,
          },
        });


      } else {
        // Catch unexpected success payload with status ≠ 1
        console.warn("Unexpected API status:", apiData?.message);
        showWarningToast(apiData?.message);
      }
    } catch (error) {
      // Optionally dispatch network error

      handleError(error, logout, navigate);
    } finally {
      setLoadingWish(false)
    }
  }
  const removeFromWishList = async () => {
    try {
      setLoadingWish(true)

      const response = await apiCall({
        url: `sharesafari/${safariSlug}/unwishlist`,
        method: "POST",
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      //check error after 200/ok
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        sharedSafariDispatch({
          type: "SET_SHARED_SAFARI_VIEW_ERROR",
          payload: apiData.errors,
        });
        console.error("API returned errors:", apiData.errors);
        return;
      }
      // updade shared sfari if status = 1
      if (apiData?.status === 1) {
        sharedSafariDispatch({
          type: 'UPDATE_SHARED_SAFARI_VIEW_DETAILS',
          payload: {
            is_wishlist: false,
          },
        });


      } else {
        // Catch unexpected success payload with status ≠ 1
        console.warn("Unexpected API status:", apiData?.message);
      }
    } catch (error) {
      // Optionally dispatch network error

      handleError(error, logout, navigate);
    } finally {
      setLoadingWish(false)
    }
  }

  const copyToClipboard = async (link) => {

    try {
      await navigator.clipboard.writeText(link);
      showWarningToast("Link Copied")
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <section className="safari_wrapper bg-white pt-4 pb-0 ">
      <Container fluid="xxl">
        <Row className="">
          <Col lg={12}>
            <div className="wrapper-skybgsafri bg-white pb-0">
              <Row className="border_bottom2 pb-4">
                <Col lg={8} md={12} sm={12} sx={12}  className={isMobileView ? '' : 'border-right'}>
                  <Row className="h-100">
                    <Col sm={12} md={12} lg={3} xs={12} className="maxWidth pb-md-3 pb-lg-0">
                      <div className="safritimg innerImg">
                        {imageError ? (
                          <div
                            style={{
                              width: "100%",
                              height: "160px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#f0f0f0",
                              color: "#666",
                              border: "1px solid #ddd",
                              fontStyle: "italic",
                              borderRadius: "10px",
                            }}
                          >
                          </div>
                        ) : (
                          <img
                            src={safariViewData?.shared_image_path}
                            alt="Shared Safari"
                            className="w-100 h-100"
                            onError={() => setImageError(true)}
                          />
                        )}
                      </div>
                    </Col>

                    <Col
                      xs={12}
                      lg={9}
                      md={12}
                      sm={12}
                      className="col-9 pt-sm-0 pt-3 maxWidth"
                    >
                      <div className="safrititles d-flex gap-2 mt-sm-2">
                        <div className="m-0 lh-1 d-inline font-devator">
                          {safariViewData?.share_safari_title}
                        </div>


                        {isLoggedIn && (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip style={{ position: 'fixed' }}>{safariViewData?.is_wishlist ? "Remove from watchlist" : "Add to watchlist"}</Tooltip>}

                          >
                            {safariViewData?.is_wishlist
                              ? <FontAwesomeIcon icon={faHeartSolid} size="xl" style={{ cursor: "pointer", color: "red" }} onClick={removeFromWishList} disabled={loadingWish} />
                              : <FontAwesomeIcon icon={faHeartRegular} size="xl" style={{ cursor: "pointer" }} onClick={addInWishList} disabled={loadingWish} />
                            }

                          </OverlayTrigger>
                        )}

                        {/* {isLoggedIn && (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip style={{ position: 'fixed' }}>{"View History"}</Tooltip>}
                          >
                            <FontAwesomeIcon icon={faHistory} size="xl" style={{ cursor: "pointer" }} disabled={true} />
                          </OverlayTrigger>
                        )} */}
                      </div>
                      <div className="date_bx font-wee pt-1">
                        {safariViewData?.types === "Fixed Departure" ? (
                          <div className="text-size-22 fw-medium font-roboto-italic">
                            <span className="text-secondry text-size-15">
                              {safariViewData?.types}
                            </span>
                            <span className="text-primary-c text-size-15">
                              {" "}
                              {formatDate(safariViewData?.start_date)} -{" "}
                              {formatDate(safariViewData?.end_date)}{" "}
                            </span><br/>
                            <span className="text-secondry text-size-15">
                              {"Cut off Date"}
                            </span>
                            <span className="text-primary-c text-size-15">
                              {" "}
                              {formatDate(safariViewData?.cut_off_date)}
                            </span>
                          </div>
                        ) : (
                          <div className="text-size-22 fw-medium font-roboto-italic">
                            <span className="text-primary-c text-size-15">
                              {" "}
                              {formatDate(safariViewData?.start_date)} -{" "}
                              {formatDate(safariViewData?.end_date)}{" "}
                            </span>
                          </div>
                        )}
                      </div>
                      <h6 className="titler_safari pt-2">
                        <Link
                          to={`/park/${safariViewData?.park_slug}`}
                          className="text-safari"
                        >
                          <i className="fa-solid fa-location-dot me-1"></i>{" "}
                          {safariViewData?.park_title}
                        </Link>
                      </h6>
                      <div className="d-flex gap-2 safari_link align-items-center pt-1">
                        <p className="mb-0">
                          Organized by{" "}
                          {safariViewData?.is_safari_operator ? 
                           <Link
                              to={`/operator/${safariViewData.organized_slug}/profile`}
                            >
                              <strong>
                                {safariViewData?.organized_by_name}
                              </strong>
                            </Link>
                          :
                            <Link
                              to={`/profile/user/${safariViewData?.organized_slug}`}
                            >
                              <strong>
                                {safariViewData?.organized_by_name}
                              </strong>
                            </Link>
                          }
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Col>
                {/* <Col md={4} className="d-lg-none mobile_didplay_none">
                  <div className="btns-safaries">
                    <Button className="join_btn newbgjoin text-center mt-sm-0 mt-2 d-block">
                      Join Safari
                    </Button>
                  </div>
                </Col> */}
                <Col lg={4} className="pt-lg-0 pt-4">
                  <Row className="px-sm-2 px-0">
                    <Col sm={6} className="col-12 mb-3">
                      <div className="safridetails_form d-flex gap-2 ">
                        <div className="iconImage">
                          <img
                            src={nightMode}
                            alt="Night Mode"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Trip Duration"
                          />
                        </div>
                        <div className="text-form">
                        <span class="mark_area">Trip Duration</span>
                         
                          <p className="mb-0">
                            {getNightDayDuration(
                              safariViewData?.start_date,
                              safariViewData?.end_date
                            )}
                          </p>
                        </div>
                      </div>
                    </Col>
                    {/* <Col sm={6} className="col-12 mb-3">
                      <div className="safridetails_form d-flex gap-3 ">
                        <div className="iconImg">
                          <img
                            src={texi}
                            alt="Taxi"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Pick & Drop"
                          />
                        </div>
                        <div className="text-form">
                        <span class="mark_area">Pick & Drop</span>
                          <p className="mb-0">{safariViewData?.}</p>
                        </div>
                      </div>
                    </Col> */}
                    <Col sm={6} className="col-12 mb-3">
                      <div className="safridetails_form d-flex gap-2">
                        <div className="icon_Image">
                          <img
                            src={carSeat}
                            alt="Seat"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Seats"
                          />
                        </div>
                        <div className="text-form">
                        <span class="mark_area">Seats</span>
                          <p className="mb-0">
                            Available Seats - {safariViewData?.share_seat}/
                            {safariViewData?.total_seat}
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col sm={6} className="col-12 mb-3">
                      <div className="safridetails_form d-flex gap-3 ">
                        <div className="icon_Image">
                          <img
                            src={gypsy}
                            alt="Icon"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Safaris"
                          />
                        </div>
                        <div className="text-form">
                        <span class="mark_area">Safaris</span>
                          <p className="mb-0">
                            {safariViewData?.no_of_safari} Shared Safari
                          </p>
                        </div>
                      </div>
                    </Col>
                    {safariViewData?.types === "Fixed Departure" && (
                      <Col sm={6} className="col-12 mb-3">
                        <div className="safridetails_form d-flex gap-3 align-items-center">
                          <div className="iconImg">
                            <img
                              src={meal}
                              alt="Icon"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="Safaris"
                            />
                          </div>
                          <div className="text-form">
                          <span class="mark_area">Meals</span>
                            <p className="mb-0">
                              {safariViewData?.meals_label}
                            </p>
                          </div>
                        </div>
                      </Col>
                    )}
                    {safariViewData?.types === "Fixed Departure" && (
                      <Col sm={6} className="col-12 mb-3">
                        <div className="safridetails_form d-flex gap-3 align-items-center">
                          <div className="iconImg">
                            <img
                              src={Camera}
                              alt="Agenda Icon"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="Theme"
                            />
                          </div>
                          <div className="text-form">
                          <span class="mark_area">Theme</span>
                            <p className="mb-0">{safariViewData?.share_safari_agenda}</p>
                          </div>
                        </div>
                      </Col>
                    )}
                    {/* <Col sm={6} className="col-12 mb-3">
                      <div className="safridetails_form d-flex gap-3 align-items-center">
                        <div className="iconImg">
                          {icon && (
                            <img
                              src={icon}
                              alt="Agenda Icon"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="Theme"
                            />
                          )}
                        </div>
                        <div className="text-form">
                          <p className="mb-0">
                            {agenda === "1"
                              ? "Photography"
                              : agenda === "3"
                              ? "Safari Experience"
                              : "Not Included"}
                          </p>
                        </div>
                      </div>
                    </Col> */}
                    <Col sm={6} className="col-12 mb-3">
                      <div className="safridetails_form d-flex gap-3 align-items-center">
                        <div className="iconImg">
                          <img
                            src={Hotel}
                            alt="Hotel"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Accommodation"
                          />
                        </div>
                        <div className="text-form">
                        <span class="mark_area">Accommodation</span>
                          <p className="mb-0">Economical</p>
                        </div>
                      </div>
                    </Col>
                    {safariViewData?.types !== "Fixed Departure" && (
                      <Col sm={6} className="col-12 mb-3">
                        <div className="safridetails_form d-flex gap-3 align-items-center">
                          <div className="iconImg">
                            <img
                              src={ruppes}
                              alt="rupees"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="Accommodation"
                            />
                          </div>
                          <div className="text-form">
                          <span class="mark_area">Cost</span>
                            <p className="mb-0">{rupeeFormat(safariViewData?.estimate_price_min)} - {rupeeFormat(safariViewData?.estimate_price_max)}</p>
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
              <Row
                className={`pt-md-4 align-items-center gx-4 pb-4 ${safariViewData?.types === "Fixed Departure"
                  ? "border_bottom2"
                  : ""
                  }`}
              >
                <Col lg={8}>
                  <div className="social-share flex-wrap d-flex gap-2 align-items-center justify-content-lg-start justify-content-between">
                    <p>Share this event with your friends:</p>
                    <div className="sociel_icons ps-xl-3">
                      <ul>
                        <li>
                          <a
                            href={`https://www.facebook.com/sharer/sharer.php?u=${fullUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="iconSize"
                          >
                            <i className="fa-brands fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href={`https://twitter.com/intent/tweet?url=https:${fullUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="iconSize"
                          >
                            <i className="fa-brands fa-x-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href={`https://www.instagram.com/?url=${fullUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="iconSize"
                          >
                            <i className="fa-brands fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href={`https://wa.me/?text=${fullUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="iconSize"
                          >
                            <i className="fa-brands fa-whatsapp"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href={`https://www.linkedin.com/shareArticle?mini=true&amp;url=${fullUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="iconSize"
                          >
                            <i className="fa-brands fa-linkedin-in"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href={`https://telegram.me/share/url?url=${fullUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="iconSize"
                          >
                            <i className="fa-solid fa-paper-plane pe-1"></i>
                          </a>
                        </li>
                        <li>
                          <span
                            className="iconSize copytoclipboard"
                            onClick={() => { copyToClipboard(fullUrl) }}
                            data-href={`${fullUrl}`}
                          >
                            <i className="fa-solid fa-link"></i>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>

                <Col lg={4} className="d-lg-block mobile_didplay_block">
                  <div className="d-flex justify-content-between flex-wrap gap-2 align-items-center mt-lg-0 mt-3">
                    <div className="pakageCost mb-2 mb-md-2 mb-xxl-0">
                      {safariViewData?.types === "Fixed Departure" && (
                        <h6 className="fs-5 mb-0 fw-bold">
                          <img src={ruppes} alt="Rupees" width="20px" />{rupeeFormat(safariViewData?.cost_per_person)} / <span className="perpersonText">Per Person</span>
                        </h6>
                      )}
                    </div>
                    <div className="btns-safaries">
                      {isLoggedIn ? (
                        <>
                          {safariViewData?.have_you_joined ?
                            <div className="btns-safaries">
                              <Link
                                to="#"
                                className="join_btn leavesafrai text-center mt-sm-0 mt-2 d-inline-block"
                                onClick={() => { unJoinSharedSafari(safariViewData) }}
                                disabled={loading}
                              >
                                Leave Safari
                              </Link>
                            </div>

                            :
                            <Link
                              to="#"
                              className="join_btn newbgjoin text-center mt-sm-0 mt-2 d-inline-block"
                              onClick={() => { joinSharedSafari(safariViewData) }}
                              disabled={loading}
                            >
                              Join Safari
                            </Link>
                          }
                        </>
                      ) : (
                        <Link
                          to={`/log-in?authclient=google&referrer=${encodeURIComponent(`/sharedsafari/${organized_slug}/${safariSlug}`)}`}
                          className="join_btn newbgjoin text-center mt-sm-0 mt-2 d-inline-block"
                        >
                          Join Safari
                        </Link>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row >
      </Container >
    </section >
  );
};

export default ShareSafariHeader;
